import React from "react";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";
import PropTypes from "prop-types";
import {
  displayVarsomePremiumLogo,
  displayVarsomePremiumMessage,
} from "../../common/helpers/helpers";
import withErrorGuard from "../../HOC/withErrorGuard";
import { getDiseaseRelationsTable } from "./DiseaseRelations/DiseaseRelationsTable";
import { getDiseaseRelationsTableMobile } from "./DiseaseRelations/DiseaseRelationsTableMobile";
import { getDrugLabelAnnotationsTable } from "./DrugLabelAnnotations/DrugLabelAnnotationsTable";
import { getDrugLabelAnnotationsTableMobile } from "./DrugLabelAnnotations/DrugLabelAnnotationsTableMobile";
import { getGuidelinesTable } from "./Guidelines/GuidelinesTable";
import { getGuidelinesTableMobile } from "./Guidelines/GuidelinesTableMobile";
import { getClinicalAnnotationsTable } from "./ClinicalAnnotations/ClinicalAnnotationsTable";
import { getClinicalAnnotationsTableMobile } from "./ClinicalAnnotations/ClinicalAnnotationsTableMobile";
import { getChemicalRelationsTable } from "./ChemicalRelations/ChemicalRelationsTable";
import { getChemicalRelationsTableMobile } from "./ChemicalRelations/ChemicalRelationsTableMobile";
import { getIsUserPremium } from "../../state/selectors/general.selectors";
import ComponentPanel from "../atoms/ComponentPanel/ComponentPanel";
import {
  sortByLatestUpdate,
  extractdrugLabelAnnotationsItems,
  sortByCuratorNotes,
  url,
  prepareDiseaseRelationsItems,
  prepareDrugLabelAnnotationsItems,
  prepareGuidelinesItems,
  PharmGKBTitles,
  getTitleDetails,
} from "./PharmGKBInternalHelpers";

class PharmGKBInternal extends React.Component {
  constructor() {
    super();
    this.expandRow = this.expandRow.bind(this);
  }

  expandRow(row) {
    // eslint-disable-next-line no-param-reassign
    row.expanded = !row.expanded;
    this.forceUpdate();
  }

  render() {
    const { result, isGene, isUserPremium } = this.props;
    const version = result ? result.version : "";
    let content = null;
    const premiumLogo = displayVarsomePremiumLogo(false);
    // We are on VarSome and user is Premium or we are on Clinical Platform.
    if (isUserPremium || __IS_COMPONENTS_PORTAL__) {
      if (result) {
        const pharmgkbData = result;
        const chemicalRelationsItems = pharmgkbData.chemical_relations;
        const diseaseRelationsItems = prepareDiseaseRelationsItems(
          pharmgkbData.disease_relations
        );
        const clinicalAnnotationsItems = pharmgkbData.clinical_annotations;
        const guidelinesItems = pharmgkbData.guidelines;
        let drugLabelAnnotationsItems = null;
        let chemicalRelationsTable = null;
        let diseaseRelationsTable = null;
        let clinicalAnnotationsTable = null;
        let guidelinesTable = null;
        let drugLabelAnnotationsTable = null;

        if (chemicalRelationsItems && chemicalRelationsItems.length > 0) {
          if (isGene) {
            const d = extractdrugLabelAnnotationsItems(chemicalRelationsItems);
            drugLabelAnnotationsItems = prepareDrugLabelAnnotationsItems(d);

            if (
              drugLabelAnnotationsItems &&
              drugLabelAnnotationsItems.length > 0
            ) {
              drugLabelAnnotationsTable = (
                <div>
                  <MediaQuery minWidth={769}>
                    {getDrugLabelAnnotationsTable(drugLabelAnnotationsItems)}
                  </MediaQuery>
                  <MediaQuery maxWidth={768}>
                    {getDrugLabelAnnotationsTableMobile(
                      drugLabelAnnotationsItems
                    )}
                  </MediaQuery>
                </div>
              );
            }
          }

          const chemicalRelationsItemsSorted = isGene
            ? chemicalRelationsItems
            : sortByCuratorNotes(chemicalRelationsItems);

          chemicalRelationsTable = (
            <div className="tw-overflow-auto">
              <MediaQuery minWidth={769}>
                {getChemicalRelationsTable(
                  chemicalRelationsItemsSorted,
                  isGene,
                  this.expandRow
                )}
              </MediaQuery>
              <MediaQuery maxWidth={768}>
                {getChemicalRelationsTableMobile(chemicalRelationsItemsSorted)}
              </MediaQuery>
            </div>
          );
        }

        if (diseaseRelationsItems && diseaseRelationsItems.length > 0) {
          diseaseRelationsTable = (
            <div>
              <MediaQuery minWidth={769}>
                {getDiseaseRelationsTable(diseaseRelationsItems)}
              </MediaQuery>
              <MediaQuery maxWidth={768}>
                {getDiseaseRelationsTableMobile(diseaseRelationsItems)}
              </MediaQuery>
            </div>
          );
        }

        if (clinicalAnnotationsItems && clinicalAnnotationsItems.length > 0) {
          clinicalAnnotationsTable = (
            <div>
              <MediaQuery minWidth={769}>
                {getClinicalAnnotationsTable(
                  clinicalAnnotationsItems,
                  this.expandRow
                )}
              </MediaQuery>
              <MediaQuery maxWidth={768}>
                {getClinicalAnnotationsTableMobile(clinicalAnnotationsItems)}
              </MediaQuery>
            </div>
          );
        }

        if (guidelinesItems && guidelinesItems.length > 0) {
          const g = sortByLatestUpdate(guidelinesItems);
          const guidelinesItemsSorted = prepareGuidelinesItems(g);
          guidelinesTable = (
            <div>
              <MediaQuery minWidth={769}>
                {getGuidelinesTable(guidelinesItemsSorted)}
              </MediaQuery>
              <MediaQuery maxWidth={768}>
                {getGuidelinesTableMobile(guidelinesItemsSorted)}
              </MediaQuery>
            </div>
          );
        }

        content = PharmGKBTitles(
          clinicalAnnotationsTable,
          guidelinesTable,
          chemicalRelationsTable,
          drugLabelAnnotationsTable,
          diseaseRelationsTable
        );
      } else {
        content = (
          <div className="varsome-inner-container">
            No data available for this gene in PharmGKB.
          </div>
        );
      }
    } else {
      // If user is not Premium and we are on VarSome display the VarSome Premium message.
      // Currently this functionality is not working since on VarSome we disable the card if no data available.
      content = (
        <div className="varsome-inner-container">
          {displayVarsomePremiumMessage()}
        </div>
      );
    }
    getTitleDetails(result);

    if (isGene) {
      return (
        <ComponentPanel
          title="PharmGKB"
          version={version}
          url={url}
          premiumLogo={premiumLogo}
          content={content}
          titleDetailsRight={getTitleDetails()}
        />
      );
    }

    return (
      <ComponentPanel
        title="PharmGKB"
        version={version}
        url={url}
        premiumLogo={premiumLogo}
        content={content}
        titleDetailsRight={getTitleDetails()}
      />
    );
  }
}

PharmGKBInternal.propTypes = {
  result: PropTypes.shape({
    version: PropTypes.string,
    gene_info: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        gene: PropTypes.string,
        gene_id: PropTypes.string,
      })
    ),
    variant_info: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        variant: PropTypes.string,
        variant_id: PropTypes.string,
      })
    ),
  }),
  isGene: PropTypes.bool,
  isUserPremium: PropTypes.bool,
};

PharmGKBInternal.defaultProps = {
  result: null,
  isGene: false,
  isUserPremium: false,
};
const mapStateToProps = (state) => {
  return {
    isUserPremium: getIsUserPremium(state),
  };
};

export default connect(
  mapStateToProps,
  {}
)(withErrorGuard(PharmGKBInternal, "PharmGKB", "PharmGKB"));
